const calculatePrice = (quantity, price, priceQuantity, decimals) => {
  if (!price) return;
  const calculated = (quantity * price) / priceQuantity;

  if (decimals) return calculated.toFixed(decimals);
  return calculated;
};

export default calculatePrice;
